import React from "react";
import { Container } from "reactstrap";
import CreateFormInput from "../CreateFormInput";
import { colors } from "../../Utils/Colors";
import { serverUrls } from "../../Utils/Urls";
import { connect } from "react-redux";
import {
  getPatient,
  getPatientFailure,
  getPatientSuccess,
  resetPatientState,
} from "../../Actions/patientAction";
import axios from "axios";

const formInputs = {
  name: {
    type: "text",
    required: true,
    placeholder: "name",
    label: "Name",
  },
  age: {
    type: "number",
    required: true,
    placeholder: "age",
    label: "Age",
  },
  sex: {
    type: "select",
    required: true,
    placeholder: "name",
    values: {
      Male: "M",
      Female: "F",
    },
    label: "Sex",
  },
  crno: {
    type: "text",
    required: true,
    placeholder: "cr no",
    label: "CR No",
  },
  admissionno: {
    type: "text",
    required: false,
    placeholder: "admission no",
    label: "Admission No.",
  },
  ecno: {
    type: "text",
    required: false,
    placeholder: "ec no",
    label: "EC No.",
  },
  DOA: {
    type: "datepicker",
    required: false,
    placeholder: "DOA",
    label: "DOA",
  },
  DOS: {
    type: "datepicker",
    required: false,
    placeholder: "DOS",
    label: "DOS",
  },
  DOD: {
    type: "datepicker",
    required: false,
    placeholder: "DOD",
    label: "DOD",
  },
  DOR: {
    type: "datepicker",
    required: false,
    placeholder: "DOR",
    label: "Date Of recruitment of patient",
  },
  address: {
    type: "text",
    required: true,
    placeholder: "address",
    label: "Address",
  },
  telephone: {
    type: "text",
    required: false,
    placeholder: "telephone",
    label: "Telephone",
  },
  mobile: {
    type: "text",
    required: true,
    placeholder: "mobile",
    label: "Mobile",
  },
  email: {
    type: "email",
    required: false,
    placeholder: "email",
    label: "Email",
  },
  aadharCard: {
    type: "text",
    required: false,
    placeholder: "aadhar card",
    label: "Aadhar Card",
    // },
    // parents: {
    //     type: 'text',
    //     required: false,
    //     placeholder: 'parents',
    //     label: 'Parents'
    // },
    // grandparents: {
    //     type: 'text',
    //     required: false,
    //     placeholder: 'grandparents',
    //     label: 'Grand Parents'
  },
  consent: {
    type: "select",
    required: true,
    placeholder: "consent",
    values: {
      Yes: "Y",
      No: "N",
    },
    label: "Have you taken the consent?",
  },
};

class UpdatePatient extends React.Component {
  componentDidMount() {
    this.props.getPatient(serverUrls.patient + this.props.id + "/");
  }
  componentWillUnmount() {
    this.props.resetPatientState();
  }

  render() {
    var url = serverUrls.patient + this.props.id + "/";
    return (
      <Container style={{ maxWidth: 800, background: colors.lightGrey }}>
        <br />
        <h4>Patient Details</h4>
        <br />
        <CreateFormInput
          isPost={false}
          buttonName="Save"
          url={url}
          formName="getPatientDetails"
          inputs={formInputs}
        />
        <br />
        <br />
      </Container>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPatient: (url) => {
      dispatch(getPatient({ loading: true }));
      axios
        .get(url)
        .then((res) => {
          dispatch(
            getPatientSuccess({
              loading: false,
              success: res.data.success,
              data: res.data,
            })
          );
        })
        .catch((err) => {
          dispatch(getPatientFailure({ loading: false }));
        });
    },
    resetPatientState: () => {
      dispatch(resetPatientState());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePatient);
